var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultRevisionSheet',{attrs:{"value":_vm.value}},[_c('div',{staticClass:"card-section"},[_c('ProductListUnitsTableDetail',{attrs:{"value":_vm.value.units,"editable":false}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }